import { apiGet } from "api/callApi";
import { DropdownWithSearch } from "InnoUI/innoinput";
import { useEffect, useState } from "react";

const TenantCoordinatorDropdown = (props) => {
  const {
    onChange,
    defaultValue,
    name = "",
    projectId = null,
    disabledDropdown,
  } = props;

  const [options, setOptions] = useState([]);

  const getAllTemplate = async () => {
    if (!options || options.length === 0) {
      try {
        let url = `/v1/getallusers?projectId=${projectId}&role=Coordinator`;
        const response = await apiGet(url, false);

        const resultOptions = response.data.map((data) => ({
          id: data.id,
          label: data.fullName,
        }));
        setOptions(resultOptions);
      } catch (error) {
        console.error("Error fetching projects", error);
      }
    }
  };

  useEffect(() => {
    getAllTemplate();
  }, []);

  const handleDropdownChange = (value) => {
    // Find the corresponding label for the selected value
    const selectedOption = options.find((data) => data.id === value);
    const selectedLabel = selectedOption ? selectedOption.label : "";

    onChange(name, value, selectedLabel);
  };

  return (
    <DropdownWithSearch
      defaultValue={defaultValue || undefined}
      placeholder="Select Coordinator"
      options={options}
      onChange={handleDropdownChange}
      borderColor="#ED850C"
      disabled={true}
      width="358px"
      dropdowType={name}
      disabledDropdown={disabledDropdown}
    />
  );
};

export default TenantCoordinatorDropdown;
